import { Topic } from '../intercom/topic';
import { CaseTransformer } from './caseTransformer';
import { DefectTransformer } from './defectTransformer';
import { FlatRateUnitTransformer } from './flatRateUnitTransformer';
import { JobTransformer } from './jobTransformer';
import { PackageTransformer } from './packageTransformer';
import { PartTransformer } from './partTransformer';
import { UserTransformer } from './userTransformer';
export class Transformer {
    static transform(ingoingLibModelVersion, outgoingLibModelVersion, payload, topic) {
        if (ingoingLibModelVersion === outgoingLibModelVersion || payload === null || payload === undefined) {
            return payload;
        }
        console.debug(`[AWP Lib] [SERVER]: Transforming [${topic}] payload from model V${ingoingLibModelVersion} to V${outgoingLibModelVersion}`);
        switch (topic) {
            case Topic.ACTIVE_CASE:
            case Topic.UPDATE_META_DATA:
                return CaseTransformer.transform(ingoingLibModelVersion, outgoingLibModelVersion, payload);
            case Topic.ADD_JOBS:
            case Topic.REMOVE_JOBS:
                return JobTransformer.transformList(ingoingLibModelVersion, outgoingLibModelVersion, payload);
            case Topic.UPDATE_JOB:
                return JobTransformer.transform(ingoingLibModelVersion, outgoingLibModelVersion, payload);
            case Topic.ADD_DEFECTS:
                return DefectTransformer.transformList(ingoingLibModelVersion, outgoingLibModelVersion, payload);
            case Topic.ADD_FLAT_RATE_UNITS:
                return FlatRateUnitTransformer.transformList(ingoingLibModelVersion, outgoingLibModelVersion, payload);
            case Topic.ADD_PACKAGES:
                return PackageTransformer.transformList(ingoingLibModelVersion, outgoingLibModelVersion, payload);
            case Topic.ADD_PARTS:
                return PartTransformer.transformList(ingoingLibModelVersion, outgoingLibModelVersion, payload);
            case Topic.ACTIVE_USER:
                return UserTransformer.transform(ingoingLibModelVersion, outgoingLibModelVersion, payload);
            default:
                return payload;
        }
    }
}
//# sourceMappingURL=transformer.js.map